<template>
  <div class="c-side">
    <div class="buttons">
      <a-form layout='inline'>
        <a-form-item v-if="canSave">
          <a-button type="primary" icon="plus" @click="showEditModal($event)">添加档案分类</a-button>
        </a-form-item>
      </a-form>
    </div>
    <div class="list">
      <perfect-scrollbar class="m-scrollbar">
      <div class="item" :class="{ 'active': !cateId }" @click="clickCategory({message_category: '', filter_name: '全部'})">
        <div class="name">全部</div>
      </div>
      <div class="item" :class="{ 'active': cateId === item.message_category }" 
        v-for="(item, index) of folders" :key="index" @click="clickCategory(item)">
        <!-- <div class="name">{{ item.filter_name }}</div> -->
        <div class="name">
          <div>{{ item.filter_name }}</div>
          <span>({{item.message_count}})</span>
        </div>
        <div class="des"></div>
        <div class="btns">
          <div v-if="canUpdate" class="btn btn-parmary" @click="showEditModal($event, item)">编辑</div>
          <div v-if="canDelete" class="btn btn-delete" @click="deleteCategory($event, item)">删除</div>
        </div>
      </div>
      </perfect-scrollbar>
    </div>
    <editModal v-if="visible" :item="modalData"/>
  </div>
</template>
<style lang="scss" scoped>
.m-scrollbar {
  height: calc(100vh - 280px);
}
</style>
<script>
import editModal from './editModal'
import authority from '@/common/mixins/authority'

export default {
  name: 'Category',
  inject: [ 'parent' ],
  provide() {
    return {
      parent: this
    }
  },
  components: {
    editModal
  },

  data() {
    return {
      loading: false,
      cateId: '',
      folders: [],
      searchParams: { q: '' },

      visible: false,
      modalData: null,
      authType:['market','xuetang'],
    }
  },
  mixins: [ authority ],
  async created() {
    await this.getList()
    this.parent.changeCategory({message_category: '', filter_name: '全部'})
  },

  methods: {
    async getList() {
      if(!this.canIndex){
          return false
      }
      let res = await this.$store.dispatch('searchMessageTypeAction', this.searchParams)
      if (res.data) {
        this.folders = res.data
      }
    },
    clickCategory(item) {
      this.cateId = item.message_category
      this.parent.changeCategory(item)
    },
    showEditModal(e, item) {
      e.stopPropagation()
      this.modalData = item
      this.visible = true
    },
    hideModal() {
      this.visible = false
    },
    submitModal() {
      this.visible = false
      this.getList()
    },
    deleteCategory(e, item) {
      e.stopPropagation()
      let that = this
      this.$confirm({
        title: `确定要删除资料分类"${item.filter_name}"?`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          return new Promise(async (resolve, reject) => {
            let res = await that.$store.dispatch('daMessagesDeleteCateAction', { params: { id: item.message_category } })
            if (res) {
              that.getList()
              resolve(res)
            }
          }).catch(error => console.log(error))
        }
      })
    }
  }
}
</script>
